export default {
  "fontElementMap": "_7rcNg",
  "elementSpacing": "FSXm-",
  "headerOne": "atuMU FSXm-",
  "headerTwo": "p1u-O FSXm-",
  "headerThree": "kdG50 FSXm-",
  "headerFour": "dfIek FSXm-",
  "headerFive": "KMWHx FSXm-",
  "headerSix": "E1QJ- FSXm-",
  "child": "_6WgLL"
};